import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import randomUUIDGenerator from "../../src/utils/randomUUIDGenerator.js";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants.js";

const {
  linksTo,
  attributeWebLink,
  htmlElement: { LINK_SPAN },
  helperAttributes: { LINK_HREF }
} = CkeditorConstants;

export default class InsertWebEmailLinkEditing extends Plugin {
  init() {
    const editor = this.editor;

    editor.conversion.for("dataDowncast").attributeToElement({
      model: LINK_HREF,
      view: (href, conversionApi) => this.createLinkElement(href, conversionApi),
      converterPriority: "high",
    });

    editor.conversion.for("editingDowncast").attributeToElement({
      model: LINK_HREF,
      view: (href, conversionApi) => this.createLinkElement(href, conversionApi),
      converterPriority: "high",
    });

    editor.conversion.for("dataDowncast").attributeToElement({
      model: LINK_SPAN,
      view: (href, conversionApi) => this.createLinkElement(href, conversionApi),
      converterPriority: "high",
    });

    editor.conversion.for("editingDowncast").attributeToElement({
      model: LINK_SPAN,
      view: (href, conversionApi) => this.createLinkElement(href, conversionApi),
      converterPriority: "high",
    });
  }

  createLinkElement(href, conversionApi) {
    const { writer } = conversionApi;
    const id = randomUUIDGenerator();
    // Check for existing links at the selection
    const modelSelection = this.editor.model.document.selection;
    const selectedElement = modelSelection.getFirstPosition().parent;
    const textValue = selectedElement.getAncestors().reverse().find(item => item.hasAttribute('class') && item.getAttribute('class').includes('ckeditor-wrapper'));
    const baseHrefId = this.editor?.baseHrefId?.concat('#') || '';
    const baseHrefPathUrl = this.editor?.baseHrefPathUrl?.concat('/') || '';
    const attributesRDFa = {
      id: id,
      rel: linksTo,
      typeof: attributeWebLink,
      class: "ref",
      resource: href,
      contenteditable: 'true',
      ...(textValue && { about: `${baseHrefPathUrl}${baseHrefId}${id}` })
    };

    return writer.createAttributeElement("span", attributesRDFa, {
      priority: 99,
      id: href,
      renderUnsafeAttributes: ["id", "about", "rel", "typeof", "resource", "contenteditable"],
    });
  }
}
